// Every integration is loaded through a relay frame we own, which also serves
// the built-in integrations themselves. That relay is the immediate parent (or
// opener) of the integration, so messages from the Missive app always arrive
// with one of these origins — on the web, in Electron (which loads
// mail.missiveapp.com remotely), and in Cordova (app <> proxy <> integration,
// where the proxy is the relay).
//
// The relay normally lives on the integrations host. The mail.missiveapp.*
// origins are a temporary back-compat allowance, not the steady state: older
// mobile clients are already shipped relaying integrations through the legacy
// client_host /iframe proxy, so for those users the parent is still mail.*.

// Each environment's integrations host, and the Missive app (client_host) that loads it.
const APP_ORIGIN_BY_INTEGRATIONS_ORIGIN = {
  'https://integrations.missiveapp.com': 'https://mail.missiveapp.com',
  'https://integrations.missiveapp.dev': 'https://mail.missiveapp.dev',
  'https://integrations-next.missiveapp.com': 'https://next.missiveapp.com',
}

const TRUSTED_ORIGINS = [
  ...Object.keys(APP_ORIGIN_BY_INTEGRATIONS_ORIGIN),
  // [legacy-client-iframe-relay] Kept while older mobile clients still relay integrations
  // through the client_host /iframe proxy. Remove this line together with the client's
  // /iframe route once those app versions are sunset.
  ...Object.values(APP_ORIGIN_BY_INTEGRATIONS_ORIGIN),
]

export const isTrustedOrigin = (origin) => TRUSTED_ORIGINS.includes(origin)

// The Missive app that opened a page served from `integrationsOrigin`. The app always
// builds integration URLs from its own integrations_host, so this pairing is exact.
export const appOriginFor = (integrationsOrigin) =>
  APP_ORIGIN_BY_INTEGRATIONS_ORIGIN[integrationsOrigin]
